import { Injectable } from '@angular/core'

const TO_FIXED = 3 //avoiding eslint magic numbers error
const LAST_INDEX = -1
const START_INDEX = 0

@Injectable()
export class NumberUtilsService {
  public determinePercentOutput(number: number): string {
    if (number != null) {
      const result = parseFloat(number.toString()).toFixed(TO_FIXED)
      return result.slice(LAST_INDEX) === '0'
        ? result.slice(START_INDEX, LAST_INDEX).concat('%')
        : result.concat('%')
    }
    return '—'
  }
}
